var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
export const AgentCardBase = styled.div `    
  background-color: ${(props) => props.theme.AgentConversationBackground};
  border-radius: 4px;  
  width: auto;
  height:auto;
  min-height:40px;
  position: relative;
  float: left;
  display: flex;
  margin-left: 20px;
  &:after {
    display: block  !important;
    border-right-color: ${(props) => props.theme.AgentConversationBackground}  !important;
    border-color: transparent ${(props) => props.theme.AgentConversationBackground}  !important ;
    border-width: 10px 15px 8px 0px; 
    border-style: solid;
    right: 100%;
    top: 25px;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    margin-top: -10px;
  }
`;
export const UserCardBase = styled.div `
  background-color: #ffffff;  
  border-radius: 4px;  
  border: solid 1px ${(props) => props.theme.button.background};
  position: relative;
  display: flex;
  margin-right: 20px;
  &:before{
    content: ' ';
    position: absolute;
    width: 0;
    height: 0;
    left: 100%;
    top: 25px;    
    border-color: transparent ${(props) => props.theme.button.background}  !important ;
    pointer-events: none;
    margin-top: -15px;
    border-width: 9px 0px 10.3px 15.3px;
    border-style: solid;
  }
  &:after {       
    border-left-color: #ffffff  !important;
    border-color: transparent #ffffff  !important ;
    border-width: 7px 0px 9px 14px;
    border-style: solid;
    left: 100%;
    top: 25px;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
    margin-top: -13px;
  }
`;
export const AgentCardBubble = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(AgentCardBase, Object.assign({}, props), children));
};
export const UserCardBubble = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(UserCardBase, Object.assign({}, props), children));
};
